




















import { Vue, Component, Prop } from 'vue-property-decorator';
import {namespace} from "vuex-class";

import NotificationMessage from "@/views/components/Home/dropup/components/NotificationMessage.vue";

import ActiveShipmentsList from "@/views/components/Home/dropup/components/ActiveShipmentList/ActiveShipmentsList.vue";
import {IActiveShipment} from "@/models/StoreModels";
import {ShipmentLogic} from "@/models/ShipmentLogic";
import {ANALYTIC_CLICKS} from "@/services/Analytics";

const activeShipmentsModule = namespace('activeShipments');

const userDataModule = namespace('userData');

@Component({
  name: 'DropupStart',
  components: {
    ActiveShipmentsList,
    NotificationMessage,
  },
})
export default class DropupStart extends Vue {
  @userDataModule.Getter('getId')
  private userId!: number;

  @activeShipmentsModule.Getter('getActiveOrderList')
  private activeShipmentList!: IActiveShipment[];

  @Prop({ default: false })
  private dropupOpen!: boolean;

  private get numNotifications(): number {
    return ShipmentLogic.countOrdersWaitingUserAction(this.activeShipmentList, this.userId);
  }

  private openDrawer() {
    if (!this.dropupOpen) {
      this.$uiBus.emit("dropup:open");
    }
  }
}
